var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopCategoryPositive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    height: 28,
    viewBox: "0 0 28 28",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    className: "printSVG",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#92D050",
    cx: 14,
    cy: 14,
    r: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,10 C7.672,10 7,9.328 7,8.5 C7,7.671 7.672,7 8.5,7 C9.329,7 10,7.671 10,8.5 C10,9.328 9.329,10 8.5,10 Z M19.5,10 C18.672,10 18,9.328 18,8.5 C18,7.671 18.672,7 19.5,7 C20.329,7 21,7.671 21,8.5 C21,9.328 20.329,10 19.5,10 Z M5,14.25 L6,14.25 C6,18.385 9.575,21.75 14,21.75 C18.425,21.75 22,18.385 22,14.25 L23,14.25 C23,18.951 18.964,22.75 14,22.75 C9.036,22.75 5,18.951 5,14.25 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopCategoryPositive);
export default __webpack_public_path__ + "static/media/top-category-positive.dae23403be9e529f4ce6ef1b0916c829.svg";
export { ForwardRef as ReactComponent };